import { useEffect } from 'react';

/**
 * Cookiebot returns its errors (unregistered domain, invalid domain group) with
 * HTTP 200 as plain text, so they would read as body copy on the privacy page.
 * A real declaration arrives as HTML instead, which is what this matches.
 */
const DECLARATION_SELECTOR =
	':scope > div *, table, [class*="CookieDeclaration"], [id^="CookieDeclaration"]:not(script)';

export const CookiebotDeclarationScript = () => {
	useEffect(() => {
		const cookieBotWrapper = document.getElementById('CookiebotDeclaration');
		if (cookieBotWrapper) {
			// Reveal the wrapper only once Cookiebot writes an actual declaration,
			// so neither its errors nor an empty wrapper take up space.
			const observer = new MutationObserver(() => {
				cookieBotWrapper.hidden =
					!cookieBotWrapper.querySelector(DECLARATION_SELECTOR);
			});
			observer.observe(cookieBotWrapper, { childList: true, subtree: true });

			const script = document.createElement('script');

			script.id = 'CookieDeclaration';
			script.type = 'text/javascript';
			script.async = true;
			script.src = `https://consent.cookiebot.com/${process.env.COOKIE_BOT_ID}/cd.js`;

			cookieBotWrapper.appendChild(script);

			return () => observer.disconnect();
		}

		return undefined;
	}, []);

	return <div id="CookiebotDeclaration" hidden />;
};
